import React, { useEffect, useState } from 'react';

/** Live-ticking SLA countdown. Green → amber (<25% left) → red (breached). */
const SlaCountdown: React.FC<{
  dueAt?: string | null;
  startedAt?: string | null;
  paused?: boolean;
  breachedAt?: string | null;
}> = ({ dueAt, startedAt, paused, breachedAt }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    const t = window.setInterval(() => tick((n) => n + 1), 30000);
    return () => window.clearInterval(t);
  }, []);

  if (!dueAt) return <span className="text-sm text-gray-400">No SLA clock</span>;

  const due = new Date(dueAt).getTime();
  const now = Date.now();
  const remaining = due - now;
  const total = startedAt ? due - new Date(startedAt).getTime() : remaining;
  const fraction = total > 0 ? remaining / total : 0;

  const fmt = (ms: number) => {
    const abs = Math.abs(ms);
    const h = Math.floor(abs / 3600000);
    const m = Math.floor((abs % 3600000) / 60000);
    if (h >= 48) return `${Math.floor(h / 24)}d ${h % 24}h`;
    return `${h}h ${m}m`;
  };

  if (breachedAt || remaining < 0) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-red-100 px-3 py-1 text-sm font-semibold text-red-700">
        <span className="h-2 w-2 rounded-full bg-red-600" />
        Breached {fmt(remaining)} ago
      </span>
    );
  }
  if (paused) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-3 py-1 text-sm font-medium text-gray-600 dark:text-gray-400">
        <span className="h-2 w-2 rounded-full bg-gray-400" />
        Paused · {fmt(remaining)} left
      </span>
    );
  }
  const warning = fraction < 0.25;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-semibold ${
        warning ? 'bg-amber-100 text-amber-800' : 'bg-green-100 text-green-700'
      }`}
    >
      <span className={`h-2 w-2 rounded-full ${warning ? 'bg-amber-500' : 'bg-green-500'}`} />
      {fmt(remaining)} left
    </span>
  );
};

export default SlaCountdown;
